import { useMutation } from "react-query";
import http from "infra/http";
import { PrevisaoOrcamentariaSaveRequest } from "../typings";

function useSavePrevisaoOrcamentaria(id?: string) {
  return useMutation(
    (data: PrevisaoOrcamentariaSaveRequest) => {
      if (id) {
        return http.put(`/v1/previsao-orcamentaria/${id}`, data);
      }
      return http.post(`/v1/previsao-orcamentaria`, data);
    },
    { retry: false }
  );
}

export default useSavePrevisaoOrcamentaria;
